import React, { useState } from "react";
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp";
import { FiMail } from "@react-icons/all-files/fi/FiMail";
import { MdTextsms } from "@react-icons/all-files/md/MdTextsms";
import { FiAlertTriangle } from "@react-icons/all-files/fi/FiAlertTriangle";
import { VscError } from "@react-icons/all-files/vsc/VscError";
import { FiCheckCircle } from "@react-icons/all-files/fi/FiCheckCircle";

const AlertModal = ({ message = "", type = "ALERT" }) => {
  return (
    <>
      <div className="mb-3">
        <div
          className={`flex content-center items-center ${
            !message ? "" : "md:flex-row"
          } flex-col mb-5 text-center`}
        >
          <div className="mb-2 md:mb-0">
            {type == "ALERT" ? (
              <FiAlertTriangle
                className={`${
                  !message ? "" : "md:text-5xl "
                }text-8xl text-primary`}
              />
            ) : null}
            {type == "ERROR" ? (
              <VscError className={"md:text-5xl text-8xl"} />
            ) : null}
            {type == "SUCCESS" ? (
              <FiCheckCircle
                className={`${
                  !message ? "" : "md:text-5xl "
                }text-8xl text-green-600`}
              />
            ) : null}
          </div>
          <div className="text-xl">{message}</div>
        </div>
      </div>
    </>
  );
};

export default AlertModal;
